import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AddCancelDialogButtons from "components/AddCancelDialogButtons";
import { fieldStyles } from 'services/utils';

const AddTrainingDialog = ({
  open,
  onClose,
  competencies,
  // trainings,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  const [selectedCompetency, setSelectedCompetency] = useState("");
  const [selectedTraining, setSelectedTraining] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  

  const validate = () => {
    const newErrors = {};
    if (!selectedCompetency) newErrors.selectedCompetency = t("admin.training.competencyRequired");
    if (!selectedTraining) newErrors.selectedTraining = t("admin.training.trainingRequired");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;
    setLoading(true);
    const data = {
      compId: selectedCompetency,
      trainingName: selectedTraining.trim(),
    };
    await handleSubmit(data);
    setLoading(false);
    handleClose();
  };

  const handleClose = () => {
    setSelectedCompetency("");
    setSelectedTraining("");
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>{t("admin.training.addTraining")}</DialogTitle>
      <DialogContent>
        <TextField
          select
          label={t("admin.training.competency") + " *"}
          value={selectedCompetency}
          onChange={(e) => setSelectedCompetency(e.target.value)}
          fullWidth
          margin="normal"
          error={!!errors.selectedCompetency}
          helperText={errors.selectedCompetency}
          sx={{
            width: "100%", // Custom width
            "& .MuiInputBase-root": { height: "50px" }, // Increase field height to match TextField
            "& .MuiSelect-select": { padding: "16px" }, // Adjust padding inside select (similar to TextField)
            "& .MuiInputLabel-root": { fontSize: "1.0rem" }, // Bigger label size
            "& .MuiSelect-icon": { top: "calc(50% - 12px)" }, // Vertically center the dropdown icon
            ...fieldStyles, // Apply your custom fieldStyles here
          }}
        >
          {competencies?.map((comp) => (
            <MenuItem key={comp.competencyId} value={comp.competencyId}>
              {comp.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label={t("admin.training.training") + " *"}
          value={selectedTraining}
          onChange={(e) => setSelectedTraining(e.target.value)}
          fullWidth
          margin="normal"
          error={!!errors.selectedTraining}
          helperText={errors.selectedTraining}
          sx={{
            width: "100%", // Custom width
            "& .MuiInputBase-root": { height: "50px" }, // Increase field height to match TextField
            "& .MuiSelect-select": { padding: "16px" }, // Adjust padding inside select (similar to TextField)
            "& .MuiInputLabel-root": { fontSize: "1.0rem" }, // Bigger label size
            "& .MuiSelect-icon": { top: "calc(50% - 12px)" }, // Vertically center the dropdown icon
            ...fieldStyles, // Apply your custom fieldStyles here
          }}
        ></TextField>
      </DialogContent>
{/* 
      {!loading ? (
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {t("admin.training.cancel")}
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            sx={{ "&:hover": { backgroundColor: "blue", color: "#fff" } }}
          >
            {t("admin.training.add")}
          </Button>
        </DialogActions>
      ) : (
        <Box display="flex" justifyContent="flex-end" p={1}>
          <CircularProgress size={20} sx={{ color: "black" }} />
        </Box>
      )} */}
      {loading ? (
  <Box display="flex" justifyContent="flex-end" p={1}>
    <CircularProgress size={20} sx={{ color: "black" }} />
  </Box>
) : (
  <AddCancelDialogButtons
    onCancel={handleClose}
    onSubmit={handleSave}
    loading={loading}
    cancelLabel={t("admin.training.cancel")}
    submitLabel={t("admin.training.add")}
  />
)}

    </Dialog>
  );
};

AddTrainingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  competencies: PropTypes.array.isRequired,
  // trainings: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default AddTrainingDialog;
